import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon } from '@mui';
import './show-more.scss';

const ShowMore = ({ list, max, onClick, showAll }) => {
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  if (list && list.length > max) {
    return (
      <div
        onClick={onClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        styleName="show-more-container"
      >
        <Icon color={colors.opacity.black0_6} style={{ paddingRight: '12px', width: '24px'}} aria-hidden="true">more_horiz</Icon>
        <div>{!showAll ? 'SHOW MORE' : 'SHOW LESS'}</div>
      </div>
    );
  }
  return null;
};

ShowMore.propTypes = {
  list: PropTypes.array,
  max: PropTypes.number,
  onClick: PropTypes.func,
  showAll: PropTypes.bool
};

export default ShowMore;
